import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { SettingsProvider } from './contexts/SettingsContext';
import * as serviceWorker from '../src/serviceWorker';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SettingsProvider>
  {/* // <React.StrictMode> */}
    <App />
  {/* // </React.StrictMode> */}
  </SettingsProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorker.register();
// reportWebVitals();
